
import React from 'react';
import { cn } from '@/lib/utils';

interface ModernLogoProps {
  className?: string;
  textClassName?: string;
}

const ModernLogo = ({ className, textClassName }: ModernLogoProps) => {
  return (
    <div className={cn("flex items-center", className)}>
      <svg
        viewBox="0 0 280 56"
        className={cn("h-8 md:h-10 w-auto", textClassName)}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Gradient definitions */}
        <defs>
          <linearGradient id="primaryGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4F46E5" />
            <stop offset="50%" stopColor="#7C3AED" />
            <stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
          <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
        </defs>
        
        {/* Complete text - Psychotherapist.help as one unit */}
        <text
          x="10"
          y="35"
          fontFamily="ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          fontSize="20"
          fontWeight="700"
          fill="url(#primaryGradient)"
          letterSpacing="-0.01em"
        >
          Psychotherapist<tspan fill="url(#accentGradient)" fontWeight="600">.help</tspan>
        </text>
        
        {/* Subtle underline accent */}
        <path
          d="M10,42 Q120,40 240,42"
          stroke="url(#primaryGradient)"
          strokeWidth="1.5"
          fill="none"
          opacity="0.4"
          strokeLinecap="round"
        />
        
        {/* Small accent dots */}
        <circle cx="245" cy="42" r="1" fill="url(#accentGradient)" opacity="0.7"/>
        <circle cx="251" cy="42" r="1" fill="url(#accentGradient)" opacity="0.5"/>
        <circle cx="257" cy="42" r="1" fill="url(#accentGradient)" opacity="0.3"/>
      </svg>
    </div>
  );
};

export default ModernLogo;
